import {Customer} from "../Model/Customer";

/**
 * Transforms customer to config object.
 */
export class CustomerToConfigTransformer {

  to(customer) {
    // @TODO.
  }

  from(data) {
    return new Customer()
      .setPostalCode(data.postalCode)
      .setFirstName(data.firstName)
      .setLastName(data.lastName)
      .setEmail(data.email)
      .setPhoneNumber(data.phoneNumber)
      .setSubscriptions(data.subscriptions || []);
  }

}
